import { makeStyles, css } from '@conexasaude/hero'
import typoMixin from '@/styles/mixins/typo-mixin'

const useStyles = makeStyles({
  cardContainer: ({ borderRadius, shadows }) => css`
    display: block;
    border: 0.5px solid '#dadee2';
    border-radius: ${borderRadius.sm};
    box-shadow: ${shadows[1]};
    gap: 24px;
    max-width: 435px;
    width: 335px;
    box-sizing: border-box;
    transition: 0.2s;
    cursor: pointer;

    &:hover {
      transform: translate3d(0, -2px, 0);
    }
  `,

  cardProfessionalInfo: ({ colors }) => css`
    padding: 16px;

    .professional-avatar-container {
      > div {
        display: flex;
        flex-direction: column;
        span {
            color: ${colors.neutral[300]};
          }
        }
      }
    }
  `,
  footerWapper: () => css`
    margin: 10px;
  `,
  cardFooter: ({ colors }) => css`
    display: flex;
    justify-content: center;
    flex-direction: column-reverse;
    margin: 10px;
    .icon {
      margin-right: 10px;
    }
    .hero-link__root {
      color: ${colors.primary[600]};
    }
  `,
  base: () => css`
    display: flex;
    align-items: center;
  `,

  cardConsultationInfo: ({ typography, colors }) => css`
    margin: 0 16px 16px;
    padding: '16px 0 0';
    border-top: 1px solid ${colors.neutral[100]};

    > div {
      + div {
        margin-top: 16px;
      }

      span:not(.mantine-Badge-inner) {
        margin-left: 8px;
        ${typoMixin({ typography }, 'body2')}
        color: ${colors.neutral[900]};
      }
    }
  `,
})

export { useStyles }
